// Fronted/src/contexts/AdminContext.js
import { createContext, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/adminService';

const AdminContext = createContext();

export const AdminProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  // Check if admin is authenticated on initial load
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const token = localStorage.getItem('token');
        if (token) {
          const response = await api.getCurrentAdmin();
          setAdmin(response.admin);
          setIsAuthenticated(true);
        }
      } catch (err) {
        console.error('Auth check error:', err);
        logout();
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  const login = async (username, password) => {
    try {
      setError(null);
      const response = await api.login({ username, password });
      console.log(response.token)
      if (response.token) {
        localStorage.setItem('token', response.token);
        localStorage.setItem('admin', JSON.stringify(response.admin));
        
        setAdmin(response.admin);
        setIsAuthenticated(true);
        
        navigate('/admin');
        return true;
      }
    } catch (err) {
      console.error('Login error:', err);
      setError(err.response?.data?.message || 'Login failed. Please try again.');
      return false;
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('admin');
    setAdmin(null);
    setIsAuthenticated(false);
    navigate('/admin/login');
  };

  const updateAdmin = async (adminData) => {
    try {
      const response = await api.put('/admin/profile', adminData);
      setAdmin(response.data.admin);
      localStorage.setItem('admin', JSON.stringify(response.data.admin));
      return true;
    } catch (err) {
      console.error('Update error:', err);
      setError(err.response?.data?.message || 'Update failed. Please try again.');
      return false;
    }
  };

  const changePassword = async (currentPassword, newPassword) => {
    try {
      await api.put('/admin/password', { currentPassword, newPassword });
      return true;
    } catch (err) {
      console.error('Password change error:', err);
      setError(err.response?.data?.message || 'Password change failed. Please try again.');
      return false;
    }
  };

  return (
    <AdminContext.Provider
      value={{
        admin,
        isAuthenticated,
        loading,
        error,
        login,
        logout,
        updateAdmin,
        changePassword,
        setError
      }}
    >
      {children}
    </AdminContext.Provider>
  );
};

export const useAdmin = () => useContext(AdminContext);